import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-605021ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-0 flex-grow flex flex-col" }
const _hoisted_2 = { class: "text-lg text-white font-bold" }
const _hoisted_3 = { class: "text-lg text-white" }

import Document from '@/interfaces/Document';
import { IonIcon, IonImg } from '@ionic/vue'
import { ref } from 'vue';
import { open } from 'ionicons/icons';
import { computed } from '@vue/reactivity'


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentDiv',
  props: {
    document: null
  },
  emits: ["showFullscreen", "openFile"],
  setup(__props: any, { emit }: { emit: ({
  (e: "showFullscreen", v: void): void,
  (e: "openFile", v: void): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  document: Document
}



const imgIsLoaded = ref(props.document.path ? false : true)

const documentType = computed(() => {
  const splittedValue = props.document.file_name.split('.')
  const index = splittedValue.length - 1
  return splittedValue[index]
})



function showFullscreen() {
  emit("showFullscreen")
}

function openFile() {
  emit("openFile")
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["relative", [props.document.path ? 'w-fit h-fit' : 'w-64 h-64']]),
    onClick: _cache[2] || (_cache[2] = ($event: any) => (showFullscreen()))
  }, [
    (props.document.path)
      ? (_openBlock(), _createBlock(_unref(IonImg), {
          key: 0,
          onIonImgDidLoad: _cache[0] || (_cache[0] = ($event: any) => (imgIsLoaded.value = true)),
          src: props.document.path,
          class: "w-auto h-auto"
        }, null, 8, ["src"]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass([[props.document.path ? '' : 'w-64 h-64'], "absolute bottom-0 left-0 right-0 p-2 h-1/2 flex flex-row items-end justify-end bg-gradient-to-t rounded-b-lg bg-opacity-10 from-black to-transparent"])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(props.document.name), 1),
        _createElementVNode("p", _hoisted_3, "Typ: " + _toDisplayString(_unref(documentType)), 1)
      ]),
      (props.document.valid_until !== Infinity)
        ? (_openBlock(), _createBlock(_unref(IonIcon), {
            key: 0,
            icon: _unref(open),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (openFile())),
            class: "w-6 mr-2 h-6 text-white font-bold cursor-pointer z-40"
          }, null, 8, ["icon"]))
        : _createCommentVNode("", true)
    ], 2), [
      [_vShow, imgIsLoaded.value]
    ])
  ], 2))
}
}

})